import { createSelector } from '@reduxjs/toolkit'
import { selectIsLebtItemPoliciesEnabled } from 'businessTraveller/selectors/itemPolicy/selectIsLebtItemPoliciesEnabled'
import { selectIsFlightChangeDateTripRequestEnabled } from 'businessTraveller/selectors/selectIsFlightChangeDateTripRequestEnabled'

export const selectIsFlightChangeDateTripRequestFlowEnabled = createSelector(
  (state: App.State) => selectIsLebtItemPoliciesEnabled(state),
  (state: App.State) => selectIsFlightChangeDateTripRequestEnabled(state),
  (isItemPoliciesEnabled, isTripRequestEnabled): boolean => isItemPoliciesEnabled && isTripRequestEnabled,
)
